import React, { useState, useEffect, useRef } from "react";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const Slider = ({ children, indexFn, displayProp, delay }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const sliderRef = useRef(null);

  // console.log(currentIndex);

  //automatic slider logic
  useEffect(() => {
    const timeoutFn = setTimeout(() => {
      if (currentIndex === children.length - 1) {
        sliderRef.current?.scrollTo(0, 0);
        setCurrentIndex(0);
      } else {
        sliderRef.current?.scrollBy(sliderRef.current?.clientWidth, 0);
      }
    }, delay);

    return () => {
      clearTimeout(timeoutFn);
    };
  }, [currentIndex, children, delay]);

  // console.log(children.length);
  // console.log(indexFn);

  return (
    <main className="slide-outer">
      <div
        className="slider-main  "
        ref={sliderRef}
        onScroll={() => {
          setCurrentIndex(
            Math.round(
              sliderRef.current?.scrollLeft / sliderRef.current?.offsetWidth
            )
          );

          indexFn(
            Math.round(
              sliderRef.current?.scrollLeft / sliderRef.current?.offsetWidth
            )
          );
        }}
      >
        {children}
      </div>
      <div className={`slider-children-arrow ${displayProp} `}>
        <div
          className="slider-children-arrow-left"
          onClick={() => {
            sliderRef.current?.scrollTo(-sliderRef.current?.clientWidth, 0);
          }}
        >
          <KeyboardArrowLeft />
        </div>
        <div
          className="slider-children-arrow-right"
          onClick={() => {
            sliderRef.current?.scrollBy(sliderRef.current?.clientWidth, 0);
          }}
        >
          <KeyboardArrowRight />
        </div>
      </div>
    </main>
  );
};

export default Slider;
